'use strict'
cb = ->
  setTimeout ( ->
    fingerprint = require 'grpn_fingerprint'
    new fingerprint
  ), 100
document.addEventListener 'DOMContentLoaded', cb, { passive: true, once: true }



// WEBPACK FOOTER //
// ./core/frontend/grpn-fingerprint.coffee